const React = require("react");
const ButtonBack = require("../../../../dumb/Button/BackB");
const {backLocation, Link} = require("../../../../../router");
const Caption = require("../../../../dumb/Caption/B");
const withState = require("../../../../../utils/withState");
const FieldD = require("../../../../dumb/Field/D");
const {account$} = require("../../../../../emitters/account");
const ReportDownload = require("../../../../dumb/ReportDownload/B");
const {DisplayIdMerchant} = require("../../../../dumb/DisplayData");
const links = require("../../../../../constants/links");
const toEllipsisMiddle = require("../../../../../utils/toEllipsisMiddle");
const {pushLocation} = require("../../../../../router");
const {LINK_DASHBOARD} = require("../../../../../constants/links");


const AccountSection = withState(() => {
  return (state, props) => {
    const account = state.account || {};

    return (
      <div className={`cfx fx1 (w1/3|w1/2@m|w@m2|lt)>1 ` + (props.className || '')}>
        <FieldD
          label={account.company}
          value={(
            <div className="layoutRow fhaS fvaC">
              <div className="w185">{account.username}</div>
              <div>{account.country || '-'}</div>
            </div>
          )}
        />
      </div>
    );
  };
}, {
  account: account$,
});

module.exports = (props) => (
  <div className="layoutRow fhaB fvaC">
    <div className="layoutRow jsSB">
      <div className="dB@m layoutRow fvaC fhaS">
        <ButtonBack
          className="m-10 mr10"
          component={Link}
          onClick={() => {
            pushLocation({path: LINK_DASHBOARD})
          }}
        />
        <Caption>Withdrawal details</Caption>
        <DisplayIdMerchant className="ml10 f23 fw3 lh34 mv10@m">
          {props.id}
        </DisplayIdMerchant>
      </div>
      {/*
            <div className="layoutRow fvaC fhaS pl20">
              <ButtonPrintA/>
              <ButtonDownloadA
                className="ml36"
              />
            </div>
          */}
    </div>
    {!!props.payments.length && (
      <ReportDownload
        className="pl10"
        urlPrefix={`/f2c/v1/console/withdrawal/${props.id}/`}
        prefix={`merchant-invoice_${props.id}`}
        // filter={{id: props.id}}
        disablePrint
      />
    )}
  </div>
)
